import anime from 'animejs';

export default function WSDynamicBackground () {

	var $this = this;

  var defaults = {
			target: 'dynamic_background',
			speed: {
				min: 13000,
				max: 13000,
			},
			numOfDataValues: 50,
			data: ({
				width: '20px',
				color: '#777777',
				dataType: 'bar',
				spacing: '5px'
			}),
	}

  this.options = {}

  // Private Methods
  function extendDefaults(source, properties) {
    var property;
    for (property in properties) {
      if (properties.hasOwnProperty(property)) {
        source[property] = properties[property];
      }
    }
    return source;
  }

  if (arguments[0] && typeof arguments[0] === 'object') {
    this.options = extendDefaults(defaults, arguments[0]);
	}

	// Public Methods
	this.target = document.getElementById(this.options.target);
	this.init = function() {
		$this.createBackground();
		$this.data($this.options.data);
	}

  const hasDynamicBackgroundPanel = document.querySelector('.paragraph--type--statistics-panel');
  if (hasDynamicBackgroundPanel) {
    this.init();
  }

}

WSDynamicBackground.prototype.data = function(options) {

	var $this = this;

	//generate bars
	$this.bars = function() {

		var bars = [];
		var numOfDataValues = $this.options.numOfDataValues;

		for(var i = 0; i < numOfDataValues; i++) {
			bars[i] = document.createElement('DIV');
			bars[i].classList.add('bar');
			bars[i].style.width = $this.options.data.width;
			bars[i].style.backgroundColor = $this.options.data.color;
			bars[i].style.marginLeft = $this.options.data.spacing;
			bars[i].style.marginRight = $this.options.data.spacing;
		}
		return bars;
	}

	//generate lines
	this.lines = function(options) {

	}

	this.generateData = (function () {

		if($this.options.data.dataType = 'bars') {

			var bars = $this.bars();
			var canvas = $this.canvas;
			var data = $this.data;

			for (var i = 0; i < bars.length; i++) {
				canvas.appendChild(bars[i]);
			}

			//animate data
			var randomValues = function () {
				$this.animatebars = new anime({
					targets: '#' + $this.options.target + ' .bar',
					scaleY: function() {
						return anime.random(-0.9, 5);
					},
					delay: function() {
						return anime.random(0, 1000);
					},
					endDelay: function() {
						return anime.random(0, 1000);
					},
					duration: function() {
						return anime.random($this.options.speed.min, $this.options.speed.max);
					},
					easing: 'linear',
					complete: randomValues,
				});
			}; randomValues();
		} else if (data.dataType = 'lines') {

		}
	})();

	//initialize "data" (lines or bars)
	var initData = (function () {
		// $this.generateData();
	})();
};

WSDynamicBackground.prototype.createBackground = function() {
	var bg = document.createElement('DIV');
	bg.classList.add('dynamic_background__canvas');
	this.target.appendChild(bg);
	this.canvas = bg;
}

document.addEventListener('DOMContentLoaded', function() {

	try {
		var lightBars = new WSDynamicBackground ({
			target: 'dynamic_background--light_theme',
			speed: {
				min: 9000,
				max: 9000,
			},
		});
	} catch(err) {
    console.warn(err);
	}

	try {
		var darkBars = new WSDynamicBackground ({
			target: 'dynamic_background--dark_theme',
			speed: {
				min: 9000,
				max: 9000,
			},
		});
	} catch(err) {
    console.warn(err);
	}
});
